















































































































































































































import Vue from 'vue';
import scheduleClient from '../../../apis';
import WxTemplate from '../../../models/WxTemplate';
import Customer from '../../../../customer/models/Customer';
import {
  ScheduleMsg,
  ScheduleMsgUnsubNotify,
  WxTpl,
  ScheduleMsgParam,
  ScheduleMsgCoupon,
  transDiv,
  transValue } from '../../../models/ScheduleMsg';
import { MustValueProps, ExcludeProps } from '../../../models/FieldType';
import scheduleRuleVuex from '../../../vuex/common';
import ScheduleMsgPreview from './ScheduleMsgPreview.vue';
import MessageBox from '../../../../mass/components/common/MessageBox.vue';
import WxTplTemplate from './WxTplTemplate.vue';
import WxTplTemplateSave from './WxTplTemplateSave.vue';
import ruleClient from '../../../../rule/apis';
import commonClient from '../../../../common/apis';
import EditDiv from './EditDiv.vue';
import SetProp from './SetProp.vue';
import CouponBox from '@/mass/components/common/CouponBox.vue';

function dripProp(name: string): string {
  return `<drip-prop contenteditable="false">#${name}</drip-prop>`;
}

enum RedirectType {
  Link = 1,
  Mini = 2,
  Coupon = 3,
  Neither = 0,
}

const wxTemplate: WxTemplate | undefined = undefined;
const tplColors: { [key: string]: string } = {};
const tplValues: { [key: string]: string } = {};
const tplPropConfigs: { [key: string]: any[] } = {};
const wxTemplateId: string | null = null;
const redirectType: RedirectType = RedirectType.Link as RedirectType;

function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    ScheduleMsgPreview,
    MessageBox,
    WxTplTemplate,
    WxTplTemplateSave,
    EditDiv,
    SetProp,
    CouponBox,
  },
  props: {
    hasUnsubscribe: {
      type: Boolean,
      default: true,
    },
    templateId: {
      type: String,
      default: null,
    },
    wxTpl: {
      type: Object,
      default: null,
    },
    unsubscribeEnabled: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultColor: '#000',
      wxTemplate,
      wxTemplateId,
      templateContent: '',
      templateContentDisplay: '',
      miniAppid: null,
      miniPagePath: null,
      redirectUrl: null,
      hackId: 0,
      showPreview: false,
      unsubNotifyEnabled: false,
      unsubNotifyReply: null,
      showTemplateSave: false,
      templateLoaded: false,
      tplColors,
      tplValues,
      tplPropConfigs,
      redirectType,
      RedirectType,
      MustValueProps,
      ExcludeProps,
      editField: null,
      prop: null,
      visable: false,
      remarkOpen: false,
      remark: null,
      code: guid(),
      showCouponBox: false,
      scene: 'activity',
      couponInfo: null,
    };
  },
  computed: {
    wxTplFields(): string[] {
      if (this.wxTemplate) {
        return this.wxTemplate!.content.match(/{{([0-9a-zA-Z]*.DATA)}}/gi)!.map((r) => {
          return r.replace(/{{/g, '').replace(/.DATA}}/, '');
        });
      } else {
        return [];
      }
    },
    optionProps(): any[] {
      return this.props.filter((r: any) => !this.MustValueProps.find((m: any) => m.fieldName === r.fieldName) && !this.ExcludeProps.find((m: any) => m.fieldName === r.fieldName));
    },
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
    tranTextProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
  },
  methods: {
    confirmSelectCoupon(res: any) {
      this.showCouponBox = false;
      this.couponInfo = {
        id: res.id,
        cardId: res.cardId,
        color: res.baseInfo.color,
        title: res.baseInfo.title,
        brandName: res.baseInfo.brandName,
        logoUrl: res.baseInfo.logoUrl,
      }
    },
    addProp() {
      this.visable = false;
    },
    checkProp(name: string) {
      this.editField = name.split('^')[0];
      const fieldName = name.split('^')[1];
      const prop = this.props.find((r: any) => r.fieldName === fieldName);
      if (this.tplValues[this.editField] && prop && this.tplValues[this.editField].indexOf(dripProp(prop.propName)) > -1) {
        this.$Message.warning('同一字段只能设置一次');
        return;
      }
      if (this.MustValueProps.find((r: any) => r.fieldName === fieldName)) {
        const propText = dripProp(prop.propName)
        if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
          this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
        } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
          this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
        } else {
          this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
        }
        this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
        if (!this.tplPropConfigs[this.editField]) {
          this.tplPropConfigs[this.editField] = [];
        }
        this.tplPropConfigs[this.editField].push({MustProp: {fieldName: fieldName}});
        this.updateField();
      } else if (fieldName === 'custom.current') {
        if (this.tplValues[this.editField] && this.tplValues[this.editField].indexOf(dripProp('系统时间')) > -1) {
          this.$Message.warning('同一字段只能设置一次');
        } else {
          const propText = dripProp('系统时间');
          if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
            this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
          } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
            this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
          } else {
            this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
          }
          this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
          if (!this.tplPropConfigs[this.editField]) {
            this.tplPropConfigs[this.editField] = [];
          }
          this.tplPropConfigs[this.editField].push({ExtendProp: {fieldName: fieldName}});
          this.updateField();
        }
      } else {
        this.prop = prop;
        this.visable = true;
      }
    },
    setProp(data: any) {
      const propText = dripProp(data.prop.propName)
      if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
        this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
      } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
        this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
      } else {
        this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
      }
      this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
      if (!this.tplPropConfigs[this.editField]) {
        this.tplPropConfigs[this.editField] = [];
      }
      if (data.prop.builtIn) {
        if (this.tplPropConfigs[this.editField].find((r) => r && r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName)) {
          const index = this.tplPropConfigs[this.editField].findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.tplPropConfigs[this.editField][index] = {OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.tplPropConfigs[this.editField].push({OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      } else {
        if (this.tplPropConfigs[this.editField].find((r) => r && r.OptionProp && r.OptionProp.fieldName === 'privateProps.' + data.prop.fieldName)) {
          const index = this.tplPropConfigs[this.editField].findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.tplPropConfigs[this.editField][index] = {OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.tplPropConfigs[this.editField].push({OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      }
      this.visable = false;
      this.updateField();
    },
    transValueText(value: string) {
      this.tranTextProps.forEach((p: any) => {
        value = value.replace(new RegExp(p.fieldName, 'g'), dripProp(p.propName));
        value = value.replace(new RegExp('\\${custom.current}', 'g'), dripProp('系统时间'));
      });
      return value;
    },
    saveTemplate() {
      this.showTemplateSave = true;
    },
    loadTemplates() {
      scheduleClient.getTemplates().success((r) => {
        const wxTemplates: WxTemplate[] = [];
        const templateList = r.templateList;
        for (const tpl of templateList) {
          wxTemplates.push(new WxTemplate(tpl));
        }
        this.templateLoaded = true;
        this.$store.commit('UPDATE_WX_TEMPLATES', wxTemplates);
        this.setWxTemplate();
      });
    },
    selectWxTemplate(templateId: string) {
      this.wxTemplate = this.wxTemplates.find((r) => r.templateId === templateId)!;
      this.templateContent = (this.wxTemplate as WxTemplate).content.replace(/\r?\n/g, '<br />').replace(/\n/g, '<br />').replace(/\.DATA\}/g, '}');
      this.templateContentDisplay = JSON.parse(JSON.stringify(this.templateContent));
      this.tplValues = {};
      this.tplColors = {};
      for (const field of this.wxTplFields) {
        this.$data.tplValues[field] = null;
        this.$data.tplColors[field] = this.defaultColor;
      }
      this.updateField();
    },
    setWxTemplate() {
      if (this.templateId) {
        this.selectWxTemplate(this.templateId);
        this.wxTemplateId = this.templateId;
      }
    },
    updateField() {
      let content = JSON.parse(JSON.stringify(this.templateContent));
      let counter = 0;
      const keys = Object.keys(this.tplValues);
      keys.forEach((i) => {
        const regx = new RegExp(`\{\{${i}\}\}`, 'g');
        let string = (!this.tplValues[i] || this.tplValues[i] === '') ? `{{${i}}}` : this.tplValues[i];
        let color = this.tplColors[i];
        if (counter === keys.length - 1) {
          color = '#999999';
          string = '<br />' + string;
        }
        content = content.replace(regx, `<span style="color:${color};">${string}</span>`).replace(/\r?\n/g, '<br />');
        counter++;
      });
      this.templateContentDisplay = content;
    },
    validateWxTplSettings(): boolean {
      if (!this.wxTemplate) {
        this.$Message.warning('请选择模板');
        return false;
      } else {
        const values = Object.values(this.tplValues);
        if (values.length < this.wxTplFields.length ||
            values.some((r) => !r || (r as string).trim() === '')) {
          this.$Message.warning('请填写完整的模板字段信息');
          return false;
        } else if (this.redirectType === RedirectType.Link) {
          if (!this.redirectUrl || this.redirectUrl.trim() === '') {
            this.$Message.warning('请填写跳转链接');
            return false;
          }
          if (this.remarkOpen && (!this.remark || this.remark.trim() === '')) {
            this.$Message.warning('请填写标签');
            return false;
          }
          return true;
        } else if (this.redirectType === RedirectType.Mini &&
                   (!this.miniAppid ||
                    this.miniAppid.trim() === '' ||
                    !this.miniPagePath ||
                    this.miniPagePath.trim() === '')) {
          this.$Message.warning('请填写完整的跳转小程序信息');
          return false;
        } else if (this.redirectType === RedirectType.Coupon && !this.couponInfo) {
          this.$Message.warning('请选择优惠券');
          return false;
        } else if (this.unsubNotifyEnabled &&
                   (!this.unsubNotifyReply || this.unsubNotifyReply.trim() === '')) {
          this.$Message.warning('请填写退订推送消息');
          return false;
        } else {
          return true;
        }
      }
    },
    confirmWxTplSettings() {
      if (this.validateWxTplSettings()) {

        const msg: ScheduleMsg = {
          WxTpl: this.formatWxTpl(),
        };
        this.$store.commit('UPDATE_SCHEDULE_MSG', msg);
        this.$store.commit('HIDE_WX_TPL_TEMPLATE_TIP');
        this.$emit('close');
      }
    },
    formatWxTpl(isSave = false): WxTpl {
      const tpl: WxTpl = {
        templateId: (this.wxTemplate! as WxTemplate).templateId,
        params: this.formatParams(),
        unsubNotify: {
          enabled: this.unsubNotifyEnabled,
        } as ScheduleMsgUnsubNotify,
      };
      if (this.unsubNotifyEnabled) {
        tpl.unsubNotify.replyText = this.unsubNotifyReply;
      }
      if (this.redirectType === RedirectType.Link) {
        tpl.url = this.redirectUrl;
        if (this.remarkOpen) {
          let code = null;
          if (isSave || this.code === null) {
            code = guid();
          } else {
            code = this.code;
          }
          tpl.remark = {
            open: true,
            remark: this.remark,
            code: code,
          };
        }
      }
      if (this.redirectType === RedirectType.Mini) {
        tpl.mini = {
          appid: this.miniAppid,
          pagepath: this.miniPagePath,
        };
      }
      if (this.redirectType === RedirectType.Coupon) {
        tpl.coupon = this.couponInfo as ScheduleMsgCoupon;
      }
      return JSON.parse(JSON.stringify(tpl));
    },
    doShowPreview() {
      if (this.validateWxTplSettings()) {
        this.showPreview = true;
      }
    },
    setTplValues() {
      if (this.scheduleRule.scheduleMsg) {
        this.tplValues = (this.scheduleRule.scheduleMsg as any).params;
      }
    },
    setFieldColor() {
      this.hackId++;
      this.updateField();
    },
    notLastAndFirstField(field: string): boolean {
      const keys = Object.keys(this.tplValues);
      return field !== keys[keys.length - 1] && field !== keys[0];
    },
    formatParams(): { [key: string]: ScheduleMsgParam } {
      const params: { [key: string]: ScheduleMsgParam } = {};
      for (const field in this.tplValues) {
        params[field] = {
          value: this.$data.tplValues[field],
          color: this.$data.tplColors[field],
          propConfigs: this.tplPropConfigs[field],
        } as ScheduleMsgParam;
      }
      return params;
    },
    setTplValueAndColors() {
      if (this.wxTpl) {
        const params = JSON.parse(JSON.stringify(this.wxTpl.params));
        const keys = Object.keys(this.tplValues);
        keys.forEach((i) => {
          this.tplColors[i] = params[i]['color'];
          this.tplValues[i] = this.transValueText(params[i]['value']);
          this.tplPropConfigs[i] = params[i]['propConfigs'];
        });
        this.updateField();
      }
    },
    setRedirect(wxTpl: WxTpl) {
      if (wxTpl) {
        if (wxTpl.mini) {
          this.redirectType = RedirectType.Mini;
          this.miniAppid = wxTpl.mini.appid;
          this.miniPagePath = wxTpl.mini.pagepath;
        } else if (wxTpl.coupon) {
          this.redirectType = RedirectType.Coupon;
          this.couponInfo = wxTpl.coupon;
        } else if (wxTpl.url) {
          this.redirectType = RedirectType.Link;
          this.redirectUrl = wxTpl.url;
          this.remarkOpen = wxTpl.remark && wxTpl.remark.open;
          this.remark = wxTpl.remark && wxTpl.remark.remark;
          // this.code = wxTpl.remark && wxTpl.remark.code
        } else {
          this.redirectType = RedirectType.Neither;
        }
      } else {
        this.redirectType = RedirectType.Link;
      }
    },
    setUnsubNotify(wxTpl: WxTpl) {
      if (wxTpl) {
        this.unsubNotifyEnabled = wxTpl.unsubNotify.enabled;
        if (wxTpl.unsubNotify.enabled) {
          this.unsubNotifyReply = wxTpl.unsubNotify.replyText;
        }
      }
    },
    doPreview(customer: Customer) {
      const tempTpl = JSON.parse(JSON.stringify(this.formatWxTpl()));
      if (tempTpl) {
        const keys = Object.keys(tempTpl.params);
        keys.forEach((i: any) => {
          tempTpl.params[i].value = transDiv(transValue(this.tranProps, tempTpl.params[i].value));
        });
      }
      ruleClient.previewTpl({
        openid: customer.openid,
        tpl: tempTpl,
      }).success((r) => {
        if (r.msg) {
          this.$Message.error(r.msg);
          this.showPreview = false;
        } else {
          this.$Message.success('发送预览成功，请在手机端查收');
          this.showPreview = false;
        }
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
        this.showPreview = false;
      }).error((e) => {
        this.$Message.error(e.toString());
        this.showPreview = false;
      });
    },
    selectText(val: string) {
      this.unsubNotifyReply = val;
    },
    showWxTplHelp() {
      this.$Modal.info({
        title: '如何管理模板消息？',
        content: '<p class="wxtpl-help">登录公众号后台，从左侧导航 功能 > 模板消息 进入管理模板消息。如首次使用，需先在“添加功能插件”中先开通。</p>',
      });
    },
    doSaveTemplate(name: string) {
      commonClient.saveWxTplTemplate({
        name: name,
        wxTpl: JSON.stringify(this.formatWxTpl(true)),
      }).success((r: any) => {
        this.showTemplateSave = false;
        this.$store.commit('ADD_WX_TPL_TEMPLATE', {
          id: r,
          name: name,
          wxTpl: this.formatWxTpl(true),
        });
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    readTemplate(template: any) {
      if (this.wxTemplates.some((tpl: WxTemplate) => {
        return tpl.templateId === template.wxTpl.templateId;
      })) {
        this.selectWxTemplate(template.wxTpl.templateId);
        this.wxTemplateId = template.wxTpl.templateId;
        this.tplValues = {};
        this.tplColors = {};
        Object.keys(template.wxTpl.params).forEach((k: string) => {
          this.tplValues[k] = JSON.parse(JSON.stringify(template.wxTpl.params[k].value));
          this.tplColors[k] = JSON.parse(JSON.stringify(template.wxTpl.params[k].color));
          if (template.wxTpl.params[k].propConfigs) {
            this.tplPropConfigs[k] = JSON.parse(JSON.stringify(template.wxTpl.params[k].propConfigs));
          } else {
            this.tplPropConfigs[k] = null;
          }
        });
        this.setRedirect(JSON.parse(JSON.stringify(template.wxTpl)));
        if (this.hasUnsubscribe) {
          this.setUnsubNotify(JSON.parse(JSON.stringify(template.wxTpl)));
        }
        this.updateField();
      } else {
        this.$Message.warning('该模板已被删除或失效');
      }
    },
  },
  mounted() {
    if (this.wxTemplates && this.wxTemplates.length > 0) {
      this.templateLoaded = true;
      this.setWxTemplate();
    } else {
      this.loadTemplates();
    }
    this.setTplValueAndColors();
    this.setRedirect(this.wxTpl);
    this.setUnsubNotify(this.wxTpl);
    window.addEventListener('click', (event: any) => {
      if (event.target.className.indexOf('ivu-dropdown-item') === -1) {
        this.visable = false;
      }
    });
  },
});
